'use client';

import type { ThemeProviderProps } from '@/components/providers/theme-provider';

import { Provider as JotaiProvider } from 'jotai';
import { SessionProvider } from 'next-auth/react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

export const ClientProviders: React.FC<ThemeProviderProps> = ({ children, ...props }: Readonly<ThemeProviderProps>) => {
  return (
    <SessionProvider>
      <JotaiProvider>
        <NextThemesProvider {...props}>{children}</NextThemesProvider>
      </JotaiProvider>
    </SessionProvider>
  );
};
